export function canManageAffiliatePayments(user) {
  return ['admin@groovedigital.com', 'simon@doubledotmedia.com'].includes(
    String(user && user.email || '').toLowerCase()
  );
}

export async function chooseAffiliatePaymentEmail(dialog, user) {
  if (!canManageAffiliatePayments(user)) return undefined;
  const result = await dialog.fire({
    title: 'Email the affiliate?',
    text: 'Would you like to send the affiliate a payment confirmation email?',
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes, send email',
    cancelButtonText: 'No, do not send',
    reverseButtons: true,
    allowOutsideClick: false,
    allowEscapeKey: false
  });
  return result.isConfirmed;
}

export function canEditAffiliatePaymentDate(user) {
  return String(user && user.email || '').toLowerCase() === 'admin@groovedigital.com';
}
